module.exports = __webpack_public_path__ + "static/media/RecoletaAlt-Medium.3ac36721.ttf";